// src/perfil-dxcc-widget.js
import { searchDxcc, getDxccByLabel } from './utils/dxcc-utils.js';
import { aplicarPrefijoCampoTelefono } from './data/dial-codes.js';

export function initPerfilDxccWidget() {
    const searchInput = document.getElementById('perfil-dxcc-search');
    const hiddenPais  = document.getElementById('perfil-pais');
    const inputDxcc   = document.getElementById('perfil-dxcc');
    const inputCQ     = document.getElementById('perfil-zona-cq');
    const inputITU    = document.getElementById('perfil-zona-itu');
    const dropdown    = document.getElementById('perfil-dxcc-dropdown');

    if (!searchInput || !dropdown) return;

    function fill(entidad) {
        hiddenPais.value = entidad ? entidad.name                                    : '';
        inputDxcc.value  = entidad ? String(entidad.dxcc)                            : '';
        inputCQ.value    = entidad && entidad.cq  != null ? String(entidad.cq)  : '';
        inputITU.value   = entidad && entidad.itu != null ? String(entidad.itu) : '';
        if (entidad) {
            aplicarPrefijoCampoTelefono(document.getElementById('perfil-telefono'), entidad.name);
        }
    }

    function hideDropdown() {
        dropdown.innerHTML = '';
        dropdown.style.display = 'none';
    }

    function renderOpciones(filtro) {
        const resultados = searchDxcc(filtro);
        dropdown.innerHTML = '';
        if (!resultados.length) { hideDropdown(); return; }

        resultados.forEach(entidad => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'dxcc-option';
            btn.textContent = `${entidad.name} (${entidad.dxcc})`;
            Object.assign(btn.style, {
                display: 'block', width: '100%', padding: '10px 12px',
                textAlign: 'left', border: '0', background: 'transparent',
                color: 'var(--color-texto)', cursor: 'pointer', font: 'inherit'
            });
            btn.addEventListener('mouseenter', () => { btn.style.background = 'var(--color-superficie-alt)'; });
            btn.addEventListener('mouseleave', () => { btn.style.background = 'transparent'; });
            btn.addEventListener('mousedown', e => {
                e.preventDefault();
                searchInput.value = btn.textContent;
                fill(entidad);
                hideDropdown();
            });
            dropdown.appendChild(btn);
        });
        dropdown.style.display = 'block';
    }

    searchInput.addEventListener('focus', () => renderOpciones(searchInput.value));

    searchInput.addEventListener('input', () => {
        const val = searchInput.value.trim();
        if (!val) { fill(null); hideDropdown(); return; }
        const exact = getDxccByLabel(val);
        if (exact) fill(exact); else fill(null);
        renderOpciones(val);
    });

    searchInput.addEventListener('blur', () => {
        setTimeout(() => {
            if (!dropdown.contains(document.activeElement)) {
                const exact = getDxccByLabel(searchInput.value.trim());
                if (!exact) { searchInput.value = ''; fill(null); }
                hideDropdown();
            }
        }, 200);
    });

    window.__sincronizarDxccWidget = () => {
        const pais = hiddenPais.value.trim();
        const code = inputDxcc.value.trim();
        searchInput.value = (pais && code) ? `${pais} (${code})` : pais;
    };
}
